module.exports = __webpack_public_path__ + "img/sky-blues.05881bed.png";